import { render, staticRenderFns } from "./PersonSheet.vue?vue&type=template&id=cc3f64d2"
import script from "./PersonSheet.vue?vue&type=script&lang=js"
export * from "./PersonSheet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports